<div class="d-flex flex-row justify-content-between align-items-center custom-dialog-heading">
  <h2 class="mb-0">Icon Picker</h2>
  <form [formGroup]="form">
    <mat-form-field class="w-100" subscriptSizing="dynamic">
      <mat-label>Search Icons</mat-label>
      <input matInput formControlName="query">
    </mat-form-field>
  </form>
</div>
<mat-dialog-content>
  <div class="icon-container">
    @for (icon of icons; track icon) {
      <div class="icon" (click)="selectIcon(icon)" [class.selected]="selectedIcon===icon">
        <mat-icon class="md-24">{{icon}}</mat-icon>
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" (click)="save()">Confirm</button>
</mat-dialog-actions>
